import { Alert } from '@designsforhealth/dfh-react-components'
import React, { FC } from 'react'

import { useSiteMetadataFrom } from '../../../../../../hooks/useSiteMetadata'
import useSiteSettings, { useSiteSettingsFrom } from '../../../../../../hooks/useSiteSettings'
import { useSiteSettingsAndMetadata } from '../../../../../../hooks/useSiteSettingsAndMetadata'
import { usePractitionerDocumentsNeeded } from '../../../../../../lib/practitioner-settings/hooks/usePractitionerDocumentsNeeded'
import { PractitionerSettings } from '../../../../../../lib/practitioner-settings/types'
import { langCodes } from '../../../../../../utils/siteSettings'
import Spacer from '../../../../../Spacer'
import { StyledLink, StyledSmallParagraph } from '../styled'
import { CommissionsOptOutMessage } from './CommissionsOptOutMessage'
import { EarnCommissionsNotification } from './EarnCommissionsNotification'

export interface DispensaryNotificationsProps {
  settings: PractitionerSettings
}

// Note: CommissionsOptOutMessage is legacy code likely to be removed in a future Account Documents updates
export const DispensaryNotifications: FC<DispensaryNotificationsProps> = ({ settings }) => {
  const siteSettingsAndMetadata = useSiteSettingsAndMetadata()
  const { commissionsOptOutForm, ...siteSettings } = useSiteSettingsFrom(siteSettingsAndMetadata)
  const { featureFlags } = useSiteMetadataFrom(siteSettingsAndMetadata) ?? {}
  const { lang } = useSiteSettings() ?? {}
  const { commissionsOptOutFormReceived } = settings.practitioner
  const { neededForCommissions } = usePractitionerDocumentsNeeded(
    settings.practitioner,
    siteSettings,
  )

  if (!neededForCommissions.length) {
    return null
  }

  return !featureFlags?.commissionsOptOut ? (
    // Commissions opt-out is not enabled, and customer has not submitted forms required
    // for receiving commissions
    <EarnCommissionsNotification docsForCommissionsNeeded={neededForCommissions} />
  ) : !commissionsOptOutFormReceived ? (
    // Customer has not opted out and is missing forms required for commissions
    <>
      <EarnCommissionsNotification docsForCommissionsNeeded={neededForCommissions} />
      <Spacer size={4} />
      {lang === langCodes.en_CA && (
        <CommissionsOptOutMessage commissionsOptOutForm={commissionsOptOutForm} />
      )}
    </>
  ) : (
    // Customer has opted out of commissions - let's give them a way to reverse course
    // NOTE: This logic seems strange but was in fact requested. It seems like we should
    // provide an explicit opt-in for reversing their decision instead.
    <>
      <Alert type="attention">You are not earning commission on your dispensary sales.</Alert>
      <StyledSmallParagraph>
        To start earning commission on your dispensary sales, submit the forms found{' '}
        <StyledLink to="/account/settings/eft-and-tax">here</StyledLink>.
      </StyledSmallParagraph>
    </>
  )
}
